//stanje tele,june,kravabik
import { Box,Input, Spacer,IconButton, Icon,Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,Table,Thead,Tbody,Tr,Th,Td,TableContainer,Text, Center,SkeletonCircle,SkeletonText } from "@chakra-ui/react"
import { MdPrint, } from "react-icons/md";
import {RiFileExcel2Fill} from "react-icons/ri"
import { useState,useEffect } from "react";
import { getStanje01 } from "../../util/apiUtil";
import { userReadOnly } from "../../util/grunt";
import '../../css/rgg.css';

export const Stanje01 = ({size='xs',_datum=new Date().toISOString().split('T')[0]}) => {
  const [datumod,setDatumOd]=useState(_datum)
  const [datumdo,setDatumDo]=useState(_datum)
  const [data,setData]=useState([]);
  const [err,setErr]=useState("");
  const [isLoading,setIsLoading]=useState(false);
  const [type,setType]=useState("normal")
  const [togglePrint,setTogglePrint]=useState(false);

  useEffect(() => {
    const getData=async()=>{
      try {
        if (type==='normal') {
          setIsLoading(true);  
        }
        
        const _res=await getStanje01({_datod:datumod,_datdo:datumdo,_type:type});
      if (type==='normal') {
        if (_res.status===200) {
          setData(_res.res);
          setErr("");
        } else {
          setErr(_res.message);
        }
      } else if (type==='pdf') {
        const file = new Blob([_res.res], { type: "application/pdf" });
          const url = window.URL.createObjectURL(file);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "Report.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
            
      } else if (type==='xlsx') {
            const blob = new Blob([_res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "filename.xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
      }
      
      } catch (error) {
        setErr(error.message);
      } finally {
        setIsLoading(false);
      }
      
    }
    getData();
  }, [datumod,datumdo,togglePrint,type])
  

  const onChangeDate=(event)=>{
    if (event.target.value.length<=10) {
      if (event.target.id.toLowerCase()==="iddatod") {
        setDatumOd(event.target.value);    
        setDatumDo(event.target.value); 
      } else {
        setDatumDo(event.target.value);
      }
      setType("normal");
    }
    
  }

  const onPrint=()=>{
    setType("pdf")
    setTogglePrint(!togglePrint);
  }
  const onExcel=()=>{
    setType("xlsx")
    setTogglePrint(!togglePrint);
  }
  const showAlert=()=>{
    if (err!=="") {
      return (
        <Alert status='error'>
          <AlertIcon />
          <AlertTitle>Greška</AlertTitle>
          <AlertDescription>{err}</AlertDescription>
      </Alert>
      )
    }
  }


  const showData=()=>{
    let d1=new Date('1900-1-1');
    let d2=new Date('1900-1-1');
    let _uktel=0;
    let _ukjun=0;
    let _ukost=0;
    if (isLoading) {
        return (
          <Box h={'50vh'}>
              <SkeletonCircle size='10' />
              <SkeletonText mt='4' noOfLines={20} spacing='3' skeletonHeight='2' />
          </Box>
        )
    } else {
      if (data.length>0 && err==="") {
   
        return (
          <Box h={'50vh'}>
            <TableContainer h={'100%'} overflowY={'scroll'} className="noscroll">
              <Table variant={'unstyled'} size={size}>
                <Thead _hover={{cursor:'pointer'}} fontSize={'2xs'}>
                  <Tr bg={'grunt2.100'} color={'grunt2.700'} key={`aaa0`} h={'1rem'}>
                      <Th textAlign={'left'} zIndex='5'  borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                      <Th textAlign={'center'} zIndex='5'  borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                      <Th textAlign={'right'} zIndex='5'  borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Telad</Th>
                      <Th textAlign={'right'} zIndex='5'  borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Junad</Th>
                      <Th textAlign={'right'} zIndex='5'  borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Ostalo</Th>
                      <Th textAlign={'right'} fontWeight={'semibold'} zIndex='5' borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Ukupno</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item,i)=>{
                    d2=d1;
                    d1=item.datum;
                    if (i===0) {
                      d2=item.datum;
                    }
                   
                    if (d1===d2 && i!==data.length-1) {
                      _uktel+=item.tele;
                      _ukjun+=item.june;
                      _ukost+=item.krava_bik;
                      return (
                        <Tr color={'grunt2'} key={`aa-${i}`}  bg={'white'} fontWeight={'normal'} 
                        _hover={{bg:'gray.100'}} h={'2rem'} >
                            <Td textAlign={'left'} fontSize={size}>{item.knjiga}</Td>
                            <Td textAlign={'center'} fontSize={size}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                            <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.tele}</Td>
                            <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.june}</Td>
                            <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.krava_bik}</Td>
                            <Td textAlign={'right'} fontSize={size} fontWeight={'semibold'}>{userReadOnly()?"--":item.ukupno}</Td>
                        </Tr>
                      )  
                    } else if (d1===d2 && i===data.length-1) {//zadnji zapis
                      _uktel+=item.tele;
                      _ukjun+=item.june;
                      _ukost+=item.krava_bik;
                      return (
                      <>
                          <Tr color={'grunt2'} key={`b-${i}`}  bg={'white'} fontWeight={'normal'}
                            _hover={{bg:'gray.100'}} h={'2rem'} >
                                <Td textAlign={'left'} fontSize={size}>{item.knjiga}</Td>
                                <Td textAlign={'center'} fontSize={size}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.tele}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.june}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.krava_bik}</Td>
                                <Td textAlign={'right'} fontSize={size} fontWeight={'semibold'}>{userReadOnly()?"--":item.ukupno}</Td>
                            </Tr>
                          <Tr fontSize={'2xs'} h={'1.5rem'}  key={`b2-${i}`}>
                                <Th textAlign={'left'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Ukupno</Th>
                                <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{new Date(d2).toLocaleDateString('hr-HR')}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_uktel}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_ukjun}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_ukost}</Th>
                                <Th textAlign={'right'} fontWeight={'semibold'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":(_uktel+_ukjun+_ukost)}</Th>
                            </Tr>
                            </>
                      )
                    } else if (d1!==d2) { //prelazak na drugu farmu
                      const _uktel1=_uktel;
                      const _ukjun1=_ukjun;
                      const _ukost1=_ukost;
                      _uktel=item.tele;
                      _ukjun=item.june;
                      _ukost=item.krava_bik;
                      
                        return (
                          <>
                            <Tr fontSize={'2xs'} h={'1.5rem'} key={`c-${i}`}>
                                <Th textAlign={'left'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Ukupno</Th>
                                <Th textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{new Date(d2).toLocaleDateString('hr-HR')}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_uktel1}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_ukjun1}</Th>
                                <Th textAlign={'right'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":_ukost1}</Th>
                                <Th textAlign={'right'} fontWeight={'semibold'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>{userReadOnly()?"--":(_uktel1+_ukjun1+_ukost1)}</Th>
                            </Tr>
                            <Tr color={'grunt2'} key={`d-${i}`}  bg={'white'} fontWeight={'normal'} 
                            _hover={{bg:'gray.100'}} h={'2rem'} >
                                <Td textAlign={'left'} fontSize={size}>{item.knjiga}</Td>
                                <Td textAlign={'center'} fontSize={size}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.tele}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.june}</Td>
                                <Td textAlign={'right'} fontSize={size}>{userReadOnly()?"--":item.krava_bik}</Td>
                                <Td textAlign={'right'} fontSize={size} fontWeight={'semibold'}>{userReadOnly()?"--":item.ukupno}</Td>
                               
                            </Tr>
                            </>
                        )
                        
                    }
                    
                    
                    
                      
                      
                    
                  
                    
                  })}
                  
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
      )  
      }
      
    }
  }

  return (
    <Box borderStyle={'solid'} borderWidth={'1px'} bg={'white'} rounded={'md'} p={'4px'}>
        <Box bg={'grunt2.700'} p={'2px'} mb={'4px'} fontWeight={'normal'} color={'white'} fontSize={'sm'} roundedTopLeft={'md'} roundedTopRight={'md'}>
            Stanje goveda po kategorijama i periodu
        </Box>
        <Box display={'flex'} flexDirection={'row'} p={'4px'} >
          <Center>
            <Text fontSize={'xs'} ml={'1rem'} mr={'4px'}>Oo:</Text>
            <Input focusBorderColor='grunt2.400' id="idDatOd" size={size} isDisabled={userReadOnly()}  type="date" variant={'outline'} fontWeight={'semibold'}
            value={datumod} onChange={onChangeDate} w={'10rem'} placeholder="Datum stanja od"/> 
            <Text fontSize={'xs'} ml={'1rem'} mr={'4px'}>Do:</Text>
            <Input focusBorderColor='grunt2.400' id="idDatDo" size={'xs'}  type="date" variant={'outline'} isDisabled={userReadOnly()} fontWeight={'semibold'}
             value={datumdo} onChange={onChangeDate} w={'10rem'} placeholder="Datum stanja do"/>
             </Center>
            <Spacer/>
            <IconButton variant={'outline'} isDisabled={userReadOnly()} colorScheme={'grunt2'} size={size} icon={<Icon as={RiFileExcel2Fill}/>} onClick={onExcel}/>
            <IconButton ml={'4px'} isDisabled={userReadOnly()} variant={'outline'} colorScheme={'grunt2'} size={size} icon={<Icon as={MdPrint}/>} onClick={onPrint}/>
            
        </Box>
        <Box p={'4px'}>
            {showAlert()}
            {showData()}
        </Box>
    </Box>
  )
}
